import React from 'react';

import { OPComponent, Container, NavBar, I18n, Navigation, Utils } from '../components';

import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from '../../constants/employerTypes';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { resetState } from './actions';
import { setEditingPatient, resetState as resetPatientState } from '../patient/actions';

import {
  getEditingCaseWithFiles,
  getEditingCasePatient,
  getEditingCaseEmployer,
  getEditingCaseEmployerType,
} from './selector';

import CaseInfoConsumer from './case_info_consumer';
import CaseInfoAirforce from './airforce/case_info';
import CaseInfoMedRecruiter from './medRecruiter/case_info';
import CaseInfoEmployer from './case_info_employer';

class CaseInfo extends OPComponent {
  static options = {
    topBar: {
      leftButtons: [NavBar.buttons.done],
      rightButtons: [NavBar.buttons.edit],
    },
    width: 700,
  };

  constructor(props) {
    super(props);

    this.state = {
      atLeastOneFormSaved: false,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Cases', 'Case Info');

    Navigation.registerForButtonEvents(this);

    //Defaults to case Info
    this.loadTitle(this.props);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.actions.resetState();
    this.props.actions.resetPatientState();
    this.props.onCloseScreen && this.props.onCloseScreen(this.state.atLeastOneFormSaved);
  }

  componentDidUpdate(prevProps, prevState) {
    // case has been deleted or user has unfollowed case
    if (prevProps.editingCase && !this.props.editingCase) {
      Navigation.close(this.props);
    }

    //If the editingCase is loaded after component mounted, recheck editingCase, applicable for employers.
    if (!prevProps.editingCase && this.props.editingCase) {
      this.loadTitle(this.props);
    }
  }

  loadTitle = (props) => {
    let title = I18n.ac('case.caseInfo');
    if (props.myInfo) {
      title = I18n.ac('case.myInfo');
    } else if (props.editingCase) {
      title = props.editingCase?.employerId
        ? I18n.ac_aec('case.residentInfo')
        : I18n.ac('case.caseInfo');
    }
    Navigation.setTitle({ title }, props.componentId);
  };

  handleEditAction = () => {
    this.setState({ atLeastOneFormSaved: true });
  };

  onEdit = () => {
    const patient = this.props.editingCasePatient;
    patient && this.props.actions.setEditingPatient(patient.patientId);
    this.setState({ atLeastOneFormSaved: true });
    Navigation.push(
      {
        screen: 'CaseForm',
        title: this.props.editingCase.name,
      },
      this.props.componentId
    );
  };

  render() {
    const props = this.props;

    if (!props.editingCase) {
      return <Container renderActivityOverlay={true} />;
    }

    const caseEmployer = props.editingCaseEmployer;
    const InfoComp = !caseEmployer
      ? CaseInfoConsumer
      : props.isAirforce
      ? CaseInfoAirforce
      : props.isMedRecruiter
      ? CaseInfoMedRecruiter
      : CaseInfoEmployer;
    if (!!InfoComp) {
      return (
        <InfoComp
          componentId={props.componentId}
          onEdit={this.handleEditAction}
          caseCreateSuccessMessage={props.caseCreateSuccessMessage}
        />
      );
    } else {
      return <Container />;
    }
  }
}

function mapStateToProps(state, ownProps) {
  const editingCaseEmployerType = getEditingCaseEmployerType(state);
  const isAirforce = editingCaseEmployerType === EMPLOYER_TYPE_AIRFORCE;
  const isMedRecruiter = editingCaseEmployerType === EMPLOYER_TYPE_MED_RECRUITER;
  return {
    editingCase: getEditingCaseWithFiles(state),
    editingCasePatient: getEditingCasePatient(state),
    editingCaseEmployer: getEditingCaseEmployer(state),
    editingCaseEmployerType,
    isAirforce,
    isMedRecruiter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        resetState,
        setEditingPatient,
        resetPatientState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseInfo);
